import React, { useEffect, useRef, useState } from "react";
import Scaffold from "../../../widget/layouts/Scaffold";
import videoLaunch from "../../../assets/videos/launch.mp4";
import { LogoImage } from "../../../widget/common/ui/Logo";
import Div from "../../../widget/common/ui/Div";
import UtilityHelper from "../../../service/utilities/UtilityHelper";
import OnboardingProvider from "../../../provider/onboarding/onboarding/OnboardingProvider";
import AppConfigurationProvider from "../../../provider/settings/AppConfigurationProvider";
import StorageKeys from "../../../const/StorageKeys";
import CacheStorage from "../../../service/storage/CacheStorage";
import AppConfigService from "../../../service/app_config/AppConfigService";
import { ResponsiveDeviceType } from "../../../widget/layouts/ScreenMedia";
import Center from "../../../widget/common/ui/Center";
import Loader from "../../../widget/common/ui/Loader";
import { isMobile } from "react-device-detect";

const SplashScreen = () => {
  const type: number = ResponsiveDeviceType();
  //const companyCode: string = process.env.REACT_APP_company_demo ?? "123456";
  const companyCode: string = UtilityHelper.getUrlCompanyCode();
  const videoRef = useRef<HTMLVideoElement | null>(null);
  const [isVideoLoaded, setIsVideoLoaded] = useState(false);

  const [flashLogo, setFlashLogo] = useState<string>("");
  const [companyName, setCompanyName] = useState<string>("");
  const [duration, setDuration] = useState<number>(0);
  const [endVideo, setEndVideo] = useState<boolean>(false);

  const handleVideoEnd = () => {
    setEndVideo(true);
  };

  const handleLoadedMetadata = (event: any) => {
    const videoDuration = event.target.duration;
    setDuration(Math.round(videoDuration));
  };

  const registerDevice = () => {
    OnboardingProvider.init(companyCode); // register device
  };

  const setDetail = () => {
    setFlashLogo(AppConfigService.get("company_user_flash_logo"));
    setCompanyName(AppConfigService.get("company_name"));
  };

  const initSplash = async () => {
    AppConfigService.init();
    CacheStorage.saveValue(
      StorageKeys.language,
      process.env.REACT_APP_defaults_lang ?? "en"
    );
    const webConfig: string = CacheStorage.getValue(StorageKeys.web_app_config);
    const webConfigStatus: boolean = UtilityHelper.isNotEmpty(webConfig);
    console.log(`webConfigStatus: ${webConfigStatus}`);

    //AppConfigurationProvider.setupTheme({ companyCode: companyCode, loginStatus: true });
    if (webConfigStatus) {
      if (endVideo) {
        AppConfigService.init();
        setDetail();
        setInterval(() => {
          OnboardingProvider.launchLogic(companyCode);
        }, 3 * 1000);
      }
    } else {
      if (duration > 0) {
        await AppConfigurationProvider.setupTheme({
          companyCode: companyCode,
          loginStatus: true,
          duration: duration,
        });
        setDetail();
      }
    }
  };

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;

    // Event when metadata is loaded (duration, dimensions)
    const handleLoadedMetadata = () => {
      console.log("Metadata loaded");
      setIsVideoLoaded(true);
    };

    // Event when enough data is loaded to play
    const handleCanPlay = () => {
      setIsVideoLoaded(true);

      // JUST INCASE THE VIDEO WONT PLAY
      if (videoRef.current && UtilityHelper.checkStandAlone() && isMobile) {
        const videoEnd: number = parseInt(videoRef.current.duration.toString());

        let seconds = 0;
        setInterval(() => {
          seconds++;
          if (seconds > videoEnd) {
            handleVideoEnd();
          }
        }, 1000);
      }
    };

    video.addEventListener("loadedmetadata", handleLoadedMetadata);
    video.addEventListener("canplay", handleCanPlay);

    // Cleanup
    return () => {
      video.removeEventListener("loadedmetadata", handleLoadedMetadata);
      video.removeEventListener("canplay", handleCanPlay);
    };
  }, []);

  useEffect(() => {
    initSplash();
    if (endVideo) {
      registerDevice();
    }
    // eslint-disable-next-line
  }, [endVideo, duration]);

  return (
    <Scaffold>
      <>
        {endVideo && (
          <Div className="launch-logo d-center">
            <Div>
              <LogoImage
                url={flashLogo}
                size={type === 3 ? 250 : `80%`}
                name={companyName}
                classNameWrap="mx-auto"
              />
            </Div>
          </Div>
        )}

        <Div className="d-flex  justify-content-center align-items-center vh-100- dvh-100 overflow-hidden ">
          {!isVideoLoaded && (
            <Center className="position-absolute">{Loader.normal()}</Center>
          )}
          {
            <video
              ref={videoRef}
              id="launch-app-player"
              src={videoLaunch}
              style={{ height: "100%", objectFit: "fill" }}
              autoPlay
              muted
              playsInline
              onEnded={handleVideoEnd}
              onLoadedMetadata={handleLoadedMetadata}
            />
          }
        </Div>
      </>
    </Scaffold>
  );
};

export default SplashScreen;
export const routeName: string = "/splash";
